export default __webpack_public_path__ + "static/media/roundArrow.94dbf9ac.svg";